import React from 'react';
import RedoIcon from '@mui/icons-material/Redo';
import UndoIcon from '@mui/icons-material/Undo';

import { redo, undo } from '../../../store/actions/editorActions';
import { isThereAnUndoableAction, isThereARedoableAction } from '../../../store/selectors/undoRedoSelectors';
import { inViewOnlyMode } from '../../../store/selectors/viewOnlyModeSelectors';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function UndoRedoButtons() {
  const dispatch = useAppDispatch();

  const canUndo = useAppSelector(isThereAnUndoableAction);
  const canRedo = useAppSelector(isThereARedoableAction);
  const isViewOnly = useAppSelector(inViewOnlyMode);

  return (
    <>
      <ToolbarIconButton
        title="Undo"
        icon={<UndoIcon />}
        disabled={isViewOnly || !canUndo}
        onClick={() => void dispatch(undo())}
      />
      <ToolbarIconButton
        title="Redo"
        icon={<RedoIcon />}
        disabled={isViewOnly || !canRedo}
        onClick={() => void dispatch(redo())}
      />
    </>
  );
}
